export const colors = {
  black: '#000000',
  anthraciteGrey: '#141414',
  grey: '#424242',
  middleGrey: '#b0b0b0',
  softGrey: '#eaeaea',
  lightGrey: '#f5f5f5',
  offWhite: '#fafafa',
  error: '#c90000',
  yellow: '#ffcc00',
}
